import axios from "axios";

export const idCardApi = {
  list: async (params: { studentName?: string; className?: string; sectionName?: string; dataSource?: string }) => {
    const res = await axios.get("/scholar-register/certificates/id-cards", { params });
    return res.data as any[];
  },
  create: async (payload: { mode: "AUTO" | "MANUAL"; studentId?: string; studentIds?: string[]; photoUrl?: string; studentName?: string; scholarNo?: string; className?: string; sectionName?: string; dob?: string; bloodGroup?: string; validUpto?: string }) => {
    const res = await axios.post("/scholar-register/certificates/id-card", payload);
    return res.data;
  },
  update: async (id: string, payload: { photoUrl?: string; studentName?: string; scholarNo?: string; className?: string; sectionName?: string; dob?: string; bloodGroup?: string; validUpto?: string }) => {
    const res = await axios.post(`/scholar-register/certificates/id-card/${id}/update`, payload);
    return res.data;
  },
  delete: async (id: string) => {
    const res = await axios.post(`/scholar-register/certificates/id-card/${id}/delete`);
    return res.data;
  },
  export: async (params: { studentName?: string; className?: string; sectionName?: string; dataSource?: string }) => {
    const res = await axios.post("/scholar-register/certificates/id-cards/export", null, { params, responseType: "blob" });
    return res;
  },
  exportPdf: async (params: { studentName?: string; className?: string; sectionName?: string; dataSource?: string }) => {
    const res = await axios.post("/scholar-register/certificates/id-cards/export/pdf", null, { params, responseType: "blob" });
    return res;
  },
  pdf: async (id: string) => {
    const res = await axios.get(`/scholar-register/certificates/id-card/${id}/pdf`, { responseType: "blob" });
    return res;
  },
  preview: async (id: string) => {
    const res = await axios.get(`/scholar-register/certificates/id-card/${id}/preview`);
    return res.data as { html: string };
  },
  upload: async (file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await axios.post("/scholar-register/certificates/id-card/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data as { url: string };
  },
  generateFilteredPdf: async (payload: {
    sessionId?: string;
    classId?: string;
    sectionId?: string;
    search?: string;
    validUpto?: string;
  }) => {
    const res = await axios.post(
      "/scholar-register/certificates/id-cards/generate-filtered/pdf",
      payload,
      { responseType: "blob" },
    );
    return res;
  },
  generateFilteredA4Pdf: async (payload: {
    sessionId?: string;
    classId?: string;
    sectionId?: string;
    search?: string;
    validUpto?: string;
  }) => {
    const res = await axios.post(
      "/scholar-register/certificates/id-cards/generate-filtered/a4",
      payload,
      { responseType: "blob" },
    );
    return res;
  },
  generateCorrectionCheckPdf: async (payload: {
    sessionId?: string;
    classId?: string;
    sectionId?: string;
    search?: string;
    validUpto?: string;
  }) => {
    const res = await axios.post(
      "/scholar-register/certificates/id-cards/generate-filtered/correction-check/pdf",
      payload,
      { responseType: "blob" },
    );
    return res;
  },
  bulkUploadManual: async (file: File, validUpto?: string) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await axios.post(
      "/scholar-register/certificates/id-cards/manual/bulk-upload",
      fd,
      {
        params: validUpto ? { validUpto } : undefined,
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return res.data;
  },
};
